import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/app-marketing/accelerate.webp";

function Banner(props) {
  return (
    <div className="mobileapp_gcc p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banenr_content">
              <h2>
                Accelerate Your App Success with App Marketing Services in Dubai
              </h2>
              <p>
                TekRevol understands the complexities of crafting and marketing
                digital Products. Our mobile app marketing experts ensure a
                hassle-free experience. Partner with our Marketing gurus to get
                the best app promotion services. They will devise a strategy to
                materialize all your concepts and thoughts and bring them to
                life through actionable campaigns that can be easily tracked.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="App Marketing Company in dubai"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
